import React, { Component } from 'react';
import { BrandInfoForm } from 'components';
import { PageContainer } from 'pages';

class AddBrandPage extends Component {
  render() {
    return (
      <PageContainer maxHeight>
        <BrandInfoForm />
      </PageContainer>
    );
  }
}

export default AddBrandPage;
